import { Fragment } from "react";
import styles from "@/components/mvp/DemoOfferPrzekonujaca.module.css";

type DemoOfferPrzekonujacaProps = {
  onClose: () => void;
};

const sections = [
  {
    title: "Prace rozbiórkowe",
    rows: [
      ["Skucie płytek ściennych", "22", "m²", "35 zł", "770 zł"],
      ["Skucie posadzki", "5", "m²", "40 zł", "200 zł"],
      ["Demontaż armatury i osprzętu", "1", "kpl", "350 zł", "350 zł"],
    ],
  },
  {
    title: "Hydroizolacja",
    rows: [
      ["Izolacja przeciwwilgociowa (2 warstwy)", "15", "m²", "55 zł", "825 zł"],
      ["Taśmy uszczelniające narożniki", "8", "mb", "18 zł", "144 zł"],
    ],
  },
  {
    title: "Okładziny ceramiczne",
    rows: [
      ["Płytki ścienne 60×120 (dostarcza klient)", "22", "m²", "95 zł", "2 090 zł"],
      ["Płytki podłogowe 60×60", "5", "m²", "85 zł", "425 zł"],
      ["Fuga epoksydowa", "27", "m²", "28 zł", "756 zł"],
    ],
  },
  {
    title: "Biały montaż",
    rows: [
      ["Miska WC wisząca ze stelażem", "1", "szt.", "1 200 zł", "1 200 zł"],
      ["Umywalka z baterią i syfonem", "1", "szt.", "850 zł", "850 zł"],
      ["Kabina prysznicowa (dostarcza klient)", "1", "szt.", "600 zł", "600 zł"],
      ["Silikonowanie i uszczelnienie", "1", "kpl", "280 zł", "280 zł"],
    ],
  },
  {
    title: "Elektryka",
    rows: [
      ["Wentylator łazienkowy z podłączeniem", "1", "szt.", "320 zł", "320 zł"],
      ["Punkt oświetleniowy", "2", "szt.", "180 zł", "360 zł"],
    ],
  },
  {
    title: "Prace wykończeniowe",
    rows: [
      ["Sufity (malowanie 2 warstwy)", "5", "m²", "38 zł", "190 zł"],
      ["Drzwi łazienkowe montaż (dostarcza klient)", "1", "szt.", "280 zł", "280 zł"],
      ["Sprzątanie końcowe", "1", "kpl", "320 zł", "320 zł"],
    ],
  },
];

export function DemoOfferPrzekonujaca({ onClose }: DemoOfferPrzekonujacaProps) {
  return (
    <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Podgląd oferty przekonującej">
      <button type="button" className={styles.close} onClick={onClose}>
        × Zamknij
      </button>

      <div className={styles.shell}>
        <article className={styles.page}>
          <div className={`${styles.annotation} ${styles.headerNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Pełny kosztorys z ilościami i cenami</span>
          </div>
          <div className={`${styles.annotation} ${styles.sectionNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Prace pogrupowane w sekcje</span>
          </div>

          <header className={styles.hero}>
            <p>Oferta przekonująca</p>
            <h1>Remont łazienki</h1>
            <div className={styles.metaGrid}>
              <span>Tomasz Nowak</span>
              <span>ul. Wróblewskiego 14 m. 7, Warszawa Wola</span>
              <span>11.07.2025 · ważna 21 dni</span>
            </div>
          </header>

          <section className={styles.tableWrap}>
            <table>
              <thead>
                <tr>
                  <th>Pozycja</th>
                  <th>Ilość</th>
                  <th>Jedn.</th>
                  <th>Cena jedn.</th>
                  <th>Wartość netto</th>
                </tr>
              </thead>
              <tbody>
                {sections.map((section) => (
                  <Fragment key={section.title}>
                    <tr className={styles.sectionRow}>
                      <td colSpan={5}>SEKCJA: {section.title}</td>
                    </tr>
                    {section.rows.map(([name, qty, unit, price, total]) => (
                      <tr key={`${section.title}-${name}`}>
                        <td>{name}</td>
                        <td>{qty}</td>
                        <td>{unit}</td>
                        <td>{price}</td>
                        <td>{total}</td>
                      </tr>
                    ))}
                  </Fragment>
                ))}
              </tbody>
            </table>
          </section>

          <section className={styles.summary}>
            <div>
              <span>Razem netto</span>
              <strong>9 960 zł</strong>
            </div>
            <div>
              <span>VAT 23%</span>
              <strong>2 291 zł</strong>
            </div>
            <div className={styles.grand}>
              <span>Razem brutto</span>
              <strong>12 251 zł</strong>
            </div>
          </section>
        </article>

        <article className={styles.page}>
          <div className={`${styles.annotation} ${styles.timelineNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Harmonogram realizacji</span>
          </div>
          <div className={`${styles.annotation} ${styles.ctaNote}`}>
            <span className={styles.dot} />
            <span className={styles.line} />
            <span className={styles.label}>Przycisk akceptacji dla klienta</span>
          </div>

          <section className={styles.twoCol}>
            <div>
              <h2>Harmonogram</h2>
              <ol className={styles.timeline}>
                <li>
                  <strong>Tydzień 1</strong>
                  <span>rozbiórka, hydroizolacja, przygotowanie podłoży</span>
                </li>
                <li>
                  <strong>Tydzień 2</strong>
                  <span>układanie płytek, biały montaż</span>
                </li>
                <li>
                  <strong>Tydzień 3</strong>
                  <span>elektryka, wykończenia, odbiór</span>
                </li>
              </ol>
            </div>
            <div className={styles.conditions}>
              <h2>Warunki</h2>
              <p><strong>Materiały:</strong> wg pozycji, materiały klienta oznaczone.</p>
              <p><strong>Płatność:</strong> 30% przed startem, 40% po płytkach, 30% po odbiorze.</p>
              <p><strong>Gwarancja:</strong> 24 miesiące na wykonanie.</p>
              <p><strong>Termin:</strong> 12-14 dni roboczych.</p>
            </div>
          </section>

          <section className={styles.lists}>
            <div>
              <h2>Założenia</h2>
              <ul>
                <li>Dostęp do lokalu w godz. 8:00-17:00</li>
                <li>Wywóz gruzu po stronie wykonawcy</li>
                <li>Materiały klienta dostarczone przed startem prac</li>
              </ul>
            </div>
            <div>
              <h2>Wyłączenia</h2>
              <ul>
                <li>Zakup płytek, kabiny i drzwi (dostarcza klient)</li>
                <li>Roboty tynkarskie poza łazienką</li>
              </ul>
            </div>
          </section>

          <section className={styles.cta}>
            <button type="button">Akceptuję ofertę</button>
            <a>Mam pytanie</a>
            <a>Proszę o zmianę</a>
          </section>
        </article>
      </div>
    </div>
  );
}
